import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import ProductsPage from "@/pages/products/page";
import ApplyPage from "@/pages/apply/page";
import AuthPage from "@/pages/auth/page";
import LicensesPage from "@/pages/licenses/page";
import SettingsPage from "@/pages/settings/page";
import NotificationsPage from "@/pages/notifications/page";
import ResetPasswordPage from "@/pages/reset-password/page";
import AdminPage from "@/pages/admin/page";
import CustomersPage from "@/pages/admin/customers/page";
import AuditLogPage from "@/pages/admin/audit/page";
import MonitorPage from "@/pages/admin/monitor/page";
import StaffPage from "@/pages/admin/staff/page";
import ProductsAdminPage from "@/pages/admin/products/page";
import LicenseToolsPage from "@/pages/admin/tools/page";
import ReportsPage from "@/pages/admin/reports/page";
import ApiKeysPage from "@/pages/admin/apikeys/page";
import ApprovalsPage from "@/pages/admin/approvals/page";
import HelpFeedbackPage from "@/pages/admin/help/page";
import IntegrationDocsPage from "@/pages/docs/integration/page";
import HelpCenterPage from "@/pages/help/page";
import ProtectedRoute from "@/components/base/ProtectedRoute";
import AdminRoute from "@/components/base/AdminRoute";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/auth",
    element: <AuthPage />,
  },
  {
    path: "/products",
    element: <ProductsPage />,
  },
  {
    path: "/apply",
    element: <ApplyPage />,
  },
  {
    path: "/licenses",
    element: (
      <ProtectedRoute>
        <LicensesPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/settings",
    element: (
      <ProtectedRoute>
        <SettingsPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/notifications",
    element: (
      <ProtectedRoute>
        <NotificationsPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/reset-password",
    element: <ResetPasswordPage />,
  },
  {
    path: "/admin",
    element: (
      <ProtectedRoute>
        <AdminRoute module="licenses">
          <AdminPage />
        </AdminRoute>
      </ProtectedRoute>
    ),
  },
  {
    path: "/admin/customers",
    element: (
      <ProtectedRoute>
        <AdminRoute module="customers">
          <CustomersPage />
        </AdminRoute>
      </ProtectedRoute>
    ),
  },
  {
    path: "/admin/audit",
    element: (
      <ProtectedRoute>
        <AdminRoute module="audit">
          <AuditLogPage />
        </AdminRoute>
      </ProtectedRoute>
    ),
  },
  {
    path: "/admin/monitor",
    element: (
      <ProtectedRoute>
        <AdminRoute module="monitor">
          <MonitorPage />
        </AdminRoute>
      </ProtectedRoute>
    ),
  },
  {
    path: "/admin/staff",
    element: (
      <ProtectedRoute>
        <AdminRoute module="staff">
          <StaffPage />
        </AdminRoute>
      </ProtectedRoute>
    ),
  },
  {
    path: "/admin/products",
    element: (
      <ProtectedRoute>
        <AdminRoute module="products">
          <ProductsAdminPage />
        </AdminRoute>
      </ProtectedRoute>
    ),
  },
  {
    path: "/admin/tools",
    element: (
      <ProtectedRoute>
        <AdminRoute module="licenses">
          <LicenseToolsPage />
        </AdminRoute>
      </ProtectedRoute>
    ),
  },
  {
    path: "/admin/reports",
    element: (
      <ProtectedRoute>
        <AdminRoute module="reports">
          <ReportsPage />
        </AdminRoute>
      </ProtectedRoute>
    ),
  },
  {
    path: "/admin/apikeys",
    element: (
      <ProtectedRoute>
        <AdminRoute module="apikeys">
          <ApiKeysPage />
        </AdminRoute>
      </ProtectedRoute>
    ),
  },
  {
    path: "/admin/approvals",
    element: (
      <ProtectedRoute>
        <AdminRoute module="approvals">
          <ApprovalsPage />
        </AdminRoute>
      </ProtectedRoute>
    ),
  },
  {
    path: "/admin/help",
    element: (
      <ProtectedRoute>
        <AdminRoute module="help">
          <HelpFeedbackPage />
        </AdminRoute>
      </ProtectedRoute>
    ),
  },
  {
    path: "/docs/integration",
    element: <IntegrationDocsPage />,
  },
  {
    path: "/help",
    element: <HelpCenterPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;